var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsBoolean, IsInt, IsOptional, IsString, Matches, Min, ValidateNested, } from 'class-validator';
import { LOCAL_ISO_REGEX, RRULE_REGEX } from '../constants.js';
import { UpdateAppointmentSeriesDefaultsDto } from './update-appointment-series-defaults.dto.js';
/**
 * "This and following" split.
 *
 * Caps the existing series A with `UNTIL = occurrenceKey(N-1)`, creates
 * series B starting at `fromOccurrenceKey` with `newRrule`. Future overrides
 * + cancellations + EXDATEs in A whose key >= `fromOccurrenceKey` are
 * re-pointed to B.
 *
 * If `fromOccurrenceKey` itself is already a customized override (Q8a), the
 * server returns 409 unless `overrideAtSplitPointAck: true` (the user has
 * explicitly confirmed overwriting the per-occurrence customization).
 *
 * If B's rrule no longer covers a re-pointed override key (Q8h), that row is
 * detached to a standalone appointment (`seriesId = null`) with audit log;
 * the response includes the list of orphaned override ids.
 */
export class SplitAppointmentSeriesDto {
    fromOccurrenceKey;
    newRrule;
    newExpectedOccurrenceCount;
    newDefaults;
    overrideAtSplitPointAck;
    confirmConflicts;
}
__decorate([
    Matches(LOCAL_ISO_REGEX, {
        message: 'fromOccurrenceKey must be local-time ISO `YYYY-MM-DDTHH:mm:ss` (no offset)',
    }),
    __metadata("design:type", String)
], SplitAppointmentSeriesDto.prototype, "fromOccurrenceKey", void 0);
__decorate([
    IsString(),
    Matches(RRULE_REGEX, {
        message: 'newRrule must be a valid RFC 5545 RRULE string',
    }),
    __metadata("design:type", String)
], SplitAppointmentSeriesDto.prototype, "newRrule", void 0);
__decorate([
    IsInt(),
    Min(1),
    IsOptional(),
    __metadata("design:type", Number)
], SplitAppointmentSeriesDto.prototype, "newExpectedOccurrenceCount", void 0);
__decorate([
    ValidateNested(),
    Type(() => UpdateAppointmentSeriesDefaultsDto),
    IsOptional(),
    __metadata("design:type", UpdateAppointmentSeriesDefaultsDto)
], SplitAppointmentSeriesDto.prototype, "newDefaults", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], SplitAppointmentSeriesDto.prototype, "overrideAtSplitPointAck", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], SplitAppointmentSeriesDto.prototype, "confirmConflicts", void 0);
//# sourceMappingURL=split-appointment-series.dto.js.map